import { useQuery } from 'react-query';
import { flaggedService } from 'flagged/services/flaggedService';

export function useFlaggedQuery() {
  return useQuery(['flaggedService_getFlagged'], () => flaggedService.getFlagged(), {
    refetchInterval: 10000,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
    staleTime: 10000,
    cacheTime: 5 * 60 * 1000,
    onError: (error) => {
      console.error('Error fetching flagged data:', error);
    }
  });
}
